import React from 'react';
import {Image, ImageProps, StyleSheet, View, ViewProps} from 'react-native';

import {responsive} from '../../../lib/utils';

export * from './Layout';

export const FlexImage: React.FC<ImageProps> = ({style, ...props}) => (
  <Image style={[styles.image, style]} {...props} />
);

export const ImageContainer: React.FC<ViewProps> = ({style, ...props}) => (
  <View style={[styles.imageContainer, style]} {...props} />
);

export const ContentContainer: React.FC<ViewProps> = ({style, ...props}) => (
  <View style={[styles.contentContainer, style]} {...props} />
);

export const TitleContainer: React.FC<ViewProps> = ({style, ...props}) => (
  <View style={[styles.titleContainer, style]} {...props} />
);

export const BodyContainer: React.FC<ViewProps> = ({style, ...props}) => (
  <View style={[styles.bodyContainer, style]} {...props} />
);

export const Footer: React.FC<ViewProps> = ({style, ...props}) => (
  <View style={[styles.footer, style]} {...props} />
);

export const styles = StyleSheet.create({
  imageContainer: {
    flexBasis: '60%',
    flexGrow: 1,
    flexShrink: 1,
    maxHeight: '60%',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  contentContainer: {
    flexGrow: 1,
    paddingHorizontal: 24,
  },
  titleContainer: {
    marginBottom: 24,
  },
  bodyContainer: {
    flexGrow: 1,
    paddingVertical: responsive(48),
  },
  footer: {
    marginTop: 8,
    gap: 16,
  },
});
